// Plan id → human label, shared by the Subscription page and the account
// menu. `useInfranodusLabels` is true when the account is billed through
// InfraNodus (`infranodus_uid`) or the app is not the keywordgraph variant.
export function planLabelFor(plan, useInfranodusLabels) {
    if (plan === 'FREE' || plan === 'free') return 'Free plan'
    if (useInfranodusLabels) {
        switch (plan) {
            // Native infranodus-* plans
            case 'infranodus-enterprise-annual':
            case 'infranodus-enterprise':
            case 'infranodus-enterprise-USD-Monthly':
            // KeywordGraph plans on an InfraNodus-billed account.
            // The user may have a `keywordgraph-*` plan in the DB
            // (subscribed via KG originally) but be presented as an
            // InfraNodus user because of `infranodus_uid` — show
            // the InfraNodus brand at the equivalent tier.
            case 'keywordgraph-premium-annual':
            case 'keywordgraph-premium':
            case 'keywordgraph-premium-annual-EUR-Yearly':
            case 'keywordgraph-premium-EUR-Monthly':
                return 'InfraNodus Premium'
            case 'infranodus-pro-annual':
            case 'infranodus-pro':
            case 'infranodus-advanced-annual':
            case 'infranodus-advanced':
            case 'infranodus-pro-USD-Monthly':
            case 'keywordgraph-advanced-annual':
            case 'keywordgraph-advanced':
            case 'keywordgraph-advanced-annual-EUR-Yearly':
            case 'keywordgraph-advanced-EUR-Monthly':
                return 'InfraNodus Advanced'
            case 'infranodus-cloud-annual':
            case 'infranodus-cloud':
            case 'infranodus-cloud-USD-Monthly':
                return 'InfraNodus Cloud'
            case 'infranodus-basic-annual':
            case 'infranodus-basic':
            case 'keywordgraph-basic-annual':
            case 'keywordgraph-basic':
            case 'keywordgraph-basic-annual-EUR-Yearly':
            case 'keywordgraph-basic-EUR-Monthly':
                return 'InfraNodus Basic'
            default:
                return plan
        }
    }

    switch (plan) {
        case 'keywordgraph-premium-annual':
        case 'keywordgraph-premium':
        case 'keywordgraph-premium-annual-EUR-Yearly':
        case 'keywordgraph-premium-EUR-Monthly':
            return 'KeywordGraph Premium'
        case 'keywordgraph-advanced-annual':
        case 'keywordgraph-advanced':
        case 'keywordgraph-advanced-annual-EUR-Yearly':
        case 'keywordgraph-advanced-EUR-Monthly':
            return 'KeywordGraph Advanced'
        case 'infranodus-cloud-annual':
        case 'infranodus-cloud':
            return 'InfraNodus Cloud'
        case 'keywordgraph-basic-annual':
        case 'keywordgraph-basic':
        case 'keywordgraph-basic-annual-EUR-Yearly':
        case 'keywordgraph-basic-EUR-Monthly':
            return 'KeywordGraph Basic'
        default:
            return plan
    }
}

export function usesInfranodusLabels(infranodusUid) {
    return (
        Boolean(infranodusUid) ||
        !(
            typeof window !== 'undefined' &&
            window.APP_VARIANT === 'keywordgraph'
        )
    )
}
